
export default {
  props: {
    podcastId: {
      type: String,
      default: '',
    },
    podcastData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    podcastContent: {
      type: Array,
      default: () => [],
    },
  },
  asyncData ({ store, route, params: { podcast } }) {
    store.dispatch('breadcrumbs/mirror', {
      path: route.path,
      mirror: `/podcasts/${podcast}`,
    })
  },
}
